import { render, staticRenderFns } from "./SaleTerms.vue?vue&type=template&id=ba9f273e&scoped=true&"
import script from "./SaleTerms.vue?vue&type=script&lang=js&"
export * from "./SaleTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9f273e",
  null
  
)

export default component.exports